import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"

function Enroll() {
  const classnames = classModuleGenerator(styles)

  return (
    <section className={classnames("enroll-container")}>
      <div style={{ textAlign: "center" }}>
        <h4>2022年学大中职学校开放日全面开启</h4>
        <button
          onClick={() => {
            window.openJesongChatByGroup(121, 52601)
            return false
          }}
        >
          立即报名
        </button>
      </div>
    </section>
  )
}

export default Enroll

// import { Modal, Button } from "antd"
// import { useState } from "react"
// import CustomerForm from "@/component/customerForm"

// function Enroll() {
//   const [visible, setVisible] = useState(false)
//   function handleCancelModal() {
//     setVisible(false)
//   }
//   function handleShowModal() {
//     setVisible(true)
//   }
//   return (
//     <div style={{ textAlign: "center" }}>
//       <Button type="primary" onClick={handleShowModal}>
//         立即报名
//       </Button>
//       <Modal
//         title="立即报名"
//         visible={visible}
//         onCancel={handleCancelModal}
//         footer={null}
//       >
//         <CustomerForm callback={handleCancelModal} />
//       </Modal>
//     </div>
//   )
// }

// export default Enroll
